import cn from 'classnames'
import * as React from 'react'
import styles from './Divider.module.css'
import { DividerProps } from './Divider.types'

function Divider({ thickness = 'default', className, ...props }: DividerProps) {
  const dividerStyles = cn(
    styles.divider,
    {
      [styles.thicknessDefault]: thickness === 'default',
      [styles.thicknessThin]: thickness === 'thin',
    },
    className,
  )

  return (
    <div
      className={dividerStyles}
      role="separator"
      aria-orientation="horizontal"
      {...props}
    />
  )
}

export default Divider
